import React from 'react';
import { BENTO_SECTIONS } from '../../mock';
import useContent from '../../hooks/useContent';
import MediaSlideshow from './MediaSlideshow';

export default function FeatureBento({ sections, contentKey = 'home_bento' }) {
  const { data: remote } = useContent(contentKey, BENTO_SECTIONS);
  const items = sections || remote || BENTO_SECTIONS;
  return (
    <section className="relative bg-black py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 flex flex-col gap-28 md:gap-40">
        {items.map((b, idx) => {
          const reverse = idx % 2 === 1;
          const hasSlideshow = b.media && b.media.length > 0;
          return (
            <div
              key={b.title + idx}
              id={b.id}
              className={`scroll-mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-center ${reverse ? 'md:[direction:rtl]' : ''}`}
            >
              <div className="md:col-span-6 [direction:ltr]">
                <div className="group relative overflow-hidden rounded-md aspect-[4/3] shadow-2xl">
                  {hasSlideshow ? (
                    <MediaSlideshow media={b.media} alt={b.title} />
                  ) : (
                    <img
                      src={b.img}
                      alt={b.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  )}
                </div>
              </div>
              <div className="md:col-span-6 [direction:ltr]">
                <h3 className="font-display text-[#f4efe6] uppercase text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight mb-6 whitespace-pre-line">
                  {b.title}
                </h3>
                <p className="text-[#cfc8bb] text-base md:text-lg leading-relaxed max-w-xl">
                  {b.body}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
